import { PaymentType, BrokerRegion } from '@ace-clublabs/payment-types';
import { AppFlow } from '@lib/web-shared';

export enum ErrorType {
  SYSTEM_ERROR = 'SYSTEM_ERROR',
  SOFT_ERROR = 'SOFT_ERROR',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  STANDALONE_AUTOPAY_ERROR = 'STANDALONE_AUTOPAY_ERROR',
  TEMPORARILY_UNAVAILABLE_ERROR = 'TEMPORARILY_UNAVAILABLE_ERROR',
  UNKNOWN = 'UNKNOWN',
  BOT_ERROR = 'BOT_ERROR',
}

export enum AlreadyPaidOptions {
  AdditionalPayment = 'payAdditionalAmount',
  EnrollInAutoPay = 'enrollInAutoPay',
}

export interface IGetPolicyPaymentInfoRequest {
  policyNumber: string;
  clubCode?: string;
  appFlow?: AppFlow;
  brokerRegion?: BrokerRegion;
}

export interface IGetPolicyPaymentInfoResponse {
  minimumDue: number;
  fullBalance: number;
  lastName: string;
  status: number;
  email?: string;
  allowAutoPay: boolean;
  autoPayFeatureIsOffline: boolean;
  isEnrolledInAutoPay: boolean;
}

export interface IPaymentTypeSubmit {
  paymentMethod: PaymentType;
}

export interface IInitializePaymentRequest {
  appFlow: AppFlow;
  amountPaid: number;
  autoPay?: boolean;
  policyNumber: string;
  allowAutoPay: boolean;
  clubCode?: string;
  clubTag?: string;
  brokerRegion?: string;
}

export interface IInitializePaymentResponse {
  manifestId: string;
}

export interface IGetTransactionStatusRequest {
  transactionId: string;
}
